import React, { Fragment, useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Icon, message, Row, Table, Tag } from 'antd';
import InfoRow from '../../../components/common/info-row';
import { useParams } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import { INVOICE_REFUND_ENDPOINT, TEMPLATE } from '../../../services/endpoint';
import { currencyVND, dateToString } from '../../../utils';
import Payment from './Payment';

const CustomerRefundDetail = (props) => {

	const [refundDetail, setRefundDetail] = React.useState({});
	const [summary, setSummary] = React.useState({});
	const [visible, setVisible] = useState(false);
	const [reload, setReload] = useState(0);

	const { id } = useParams();

	const columns = [
		{
			title: 'STT',
			dataIndex: 'key',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			render: (text, record) => (
				<div>
					<a style={{ cursor: 'pointer' }} onClick={() => window.open('/product/' + record.productId)}>{text}</a>
				</div>
			)
		},
		{
			title: 'Số lượng',
			dataIndex: 'quantity',
			key: 'quantity',
			width: 100
		},
		{
			title: 'Đơn giá trả',
			dataIndex: 'unitPrice',
			render: val => currencyVND(val),
			width: 150
		},
		{
			title: 'Thành tiền',
			dataIndex: 'totalPrice',
			key: 'total',
			render: val => currencyVND(val),
			width: 150
		}
	];

	const init = () => {
		window.setLoading(true);
		CommonService.findById(INVOICE_REFUND_ENDPOINT, id).then(res => {
			if (res.status === 200) {
				setRefundDetail(res.data);
			}
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => window.setLoading(false));
	};

	useEffect(() => {
		if (reload !== 0) {
			init();
		}
	}, [reload]);

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		const refundQuantity = refundDetail?.refundProducts?.reduce((acc, item) => acc + item.quantity, 0);
		const totalPriceRefund = refundDetail?.refundProducts?.reduce((acc, item) => acc + item.totalPrice, 0);
		setSummary({
			refundQuantity,
			totalPriceRefund
		});
	}, [refundDetail]);

	const renderSummaryRefundDetail = () => {
		if (refundDetail.invoiceExchangeId) {
			const amount = refundDetail.totalRefundAmount - refundDetail.totalExchangeAmount;
			return <div style={{ marginTop: 16 }}>
				<p>{`Số lượng trả: ${summary.refundQuantity} sản phẩm`}</p>
				<p>Cần hoàn tiền hàng trả: <>{currencyVND(refundDetail?.totalRefundAmount || 0)}</></p>
				<p>Khách cần trả đơn đổi (<a
					onClick={() => window.open('/orders/' + refundDetail.invoiceExchangeId)}>{refundDetail?.invoiceExchangeCode}</a>
					): <span>{currencyVND(refundDetail.totalExchangeAmount || 0)}</span></p>
				<p>
					{amount < 0 ? <b>Tổng tiền cần thu của khách :</b> : <b>Tổng tiền cần hoàn trả khách:</b>}
					<span
						style={{ color: 'red' }}> {currencyVND(amount)}</span>
				</p>
			</div>;
		} else {
			return <div style={{ marginTop: 16 }}>
				<p>{`Số lượng trả: ${summary.refundQuantity} sản phẩm`}</p>
				{/*{<p>Cần hoàn tiền hàng trả: <>{currencyVND(refundDetail?.totalRefundAmount || 0)}</></p>}*/}
				<p><b>Tổng tiền cần hoàn trả khách:</b><span
					style={{ color: 'red' }}> {currencyVND(refundDetail?.totalRefundAmount || 0)}</span>
				</p>
			</div>;
		}
	};

	const expandedRowRender = (record) => {
		const imeiList = record?.imeis;
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<div className={'mt-20 mb-20'}>
					<i>Danh sách IMEI đã chọn ({imeiList?.length || 0}): </i>{imeiList?.map((el) => <Tag color={'blue'} key={el}>
					{el}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	const getExpandedRowKeys = () => {
		return refundDetail?.refundProducts?.filter(el => el.imeis).map(el => el.productId) || [];
	};

	const handlePrint = async () => {
		try {
			window.setLoading(true);
			const res = await CommonService.get(`${TEMPLATE}/invoice-refund/${id}`, {});
			let data = res?.data.replace('<title>', '');
			data = data.replace('</title>', '');
			data = data.replace('Title', '');

			const iframe = document.createElement('iframe');
			iframe.style.position = 'fixed';
			iframe.style.right = '0';
			iframe.style.bottom = '0';
			iframe.style.width = '0';
			iframe.style.height = '0';
			iframe.style.border = '0';
			document.body.appendChild(iframe);

			const iframeDoc = iframe.contentWindow || iframe.contentDocument;
			iframeDoc.document.open();
			iframeDoc.document.write(data);
			iframeDoc.document.close();

			iframe.onload = () => {
				iframe.contentWindow.focus();
				iframe.contentWindow.print();

				setTimeout(() => {
					document.body.removeChild(iframe);
				}, 1000);
			};
		} catch (e) {
			message.error('Có lỗi xảy ra, vui lòng thử lại sau');
			console.log(e);
		} finally {
			window.setLoading(false);
		}
	};

	return (
		<div>
			<h3>Mã đơn hoàn trả: {refundDetail?.invoiceRefundCode || ''}</h3>
			<Row>
				<Col span={24} className={'mb-10'}>
					<Button onClick={handlePrint}>
						<Icon type="printer" style={{ fontSize: 25 }} />
					</Button>
				</Col>
			</Row>

			<Row gutter={16}>
				<Col span={24}>
					<Card title="Thông tin phiếu">
						<Row gutter={16}>
							<Col span={12}>
								<InfoRow labelSpan={10} valueSpan={14} label={'Khách hàng'}
												 value={<a>{refundDetail?.customer?.name || ''}</a>} />
								<InfoRow labelSpan={10} valueSpan={14} label="Số điện thoại"
												 value={refundDetail?.customer?.phoneNumber || ''} />
								<InfoRow labelSpan={10} valueSpan={14} label="Mã đơn hàng gốc"
												 value={<a
													 onClick={() => window.open('/orders/' + refundDetail?.invoiceId)}>{refundDetail?.invoiceCode || ''}</a>} />
								<InfoRow labelSpan={10} valueSpan={14} label="Ngày tạo phiếu trả"
												 value={dateToString(refundDetail?.createdDate || '')} />
								{/*<InfoRow labelSpan={10} valueSpan={14} label="Ngày nhận hàng trả lại" value={moment().format('DD/MM/YYYY HH:mm')} />*/}
							</Col>
							<Col span={12}>
								<InfoRow labelSpan={10} valueSpan={14} label="Chi nhánh trả" value={refundDetail?.branchName || ''} />
								<InfoRow labelSpan={10} valueSpan={14} label="Mã đơn đổi hàng"
												 value={<a>{refundDetail?.invoiceExchangeCode || ''}</a>} />
								<InfoRow labelSpan={10} valueSpan={14} label="Nhân viên tạo phiếu"
												 value={refundDetail?.createdBy || ''} />
								<InfoRow labelSpan={10} valueSpan={14} label="Mã tham chiếu" value="---" />
							</Col>
							<Col span={24} style={{ marginTop: 16, border: '1px dotted #ccc', padding: 10 }}>
								<p><>Ghi chú:</>
									<i>{refundDetail?.note || '---'}</i></p>
							</Col>
						</Row>
					</Card>
				</Col>
			</Row>

			<Card title="Sản phẩm trả" className={'mt-20'}>
				<Table
					rowKey={record => record.productId}
					dataSource={refundDetail?.refundProducts || []}
					columns={columns}
					pagination={false}
					bordered
					expandIconAsCell={false}
					expandedRowRender={expandedRowRender}
					expandedRowKeys={getExpandedRowKeys()}
					expandIcon={() => ''}
				/>
				{renderSummaryRefundDetail()}
			</Card>

			{/* Hoàn tiền */}
			<Card title={<Fragment>
				<Row style={{ display: 'flex', alignItems: 'center' }}>
					<Col lg={20}>
						<Icon type="money-collect"
									theme="twoTone" />{refundDetail.totalRefundAmount - refundDetail.paidAmount === 0 ? ' Đã hoàn tiền' : ' Hoàn tiền'}
					</Col>
					<Col lg={4} style={{ textAlign: 'right' }}>
						{(refundDetail.paidAmount < refundDetail.totalRefundAmount && !refundDetail.invoiceExchangeId) &&
							<Button type={'primary'} onClick={() => setVisible(true)}>Thanh toán</Button>}
					</Col>
				</Row>
			</Fragment>} className={'mt-20'}>
				<>
					{!refundDetail.invoiceExchangeId ?
						<Row gutter={16} >
						<Col span={8}>Cần trả khách: <b>{currencyVND(refundDetail.totalRefundAmount)}</b></Col>
						<Col span={8} style={{ textAlign: 'center' }}>Đã hoàn
							trả: <b>{currencyVND(refundDetail.paidAmount)}</b></Col>
						<Col span={8} style={{ textAlign: 'right' }}>Còn phải trả: <b
							style={{ color: 'red' }}>{currencyVND(refundDetail.totalRefundAmount - refundDetail.paidAmount)}</b></Col>
					</Row> :
					<Alert
						message={
							(refundDetail.totalRefundAmount - refundDetail.totalExchangeAmount) < 0 ?
							<span>
              Đơn trả hàng có giá trị nhỏ hơn đơn đổi hàng. Bạn vui lòng thực hiện thanh toán trên đơn đổi hàng <a
								onClick={() => window.open('/orders/' + refundDetail.invoiceExchangeId)}>{refundDetail.invoiceExchangeCode}</a>.<br />
              Đơn trả hàng được thanh toán toàn bộ khi đơn đổi hàng được thanh toán toàn bộ.
            </span> : <span>Bạn vui lòng thực hiện hoàn tiền trên đơn đổi hàng <a
									onClick={() => window.open('/orders/' + refundDetail.invoiceExchangeId)}>{refundDetail.invoiceExchangeCode}</a></span>
						}
						type="warning"
						showIcon
					/>}
				</>
			</Card>

			<Payment visible={visible}
							 setVisible={setVisible}
							 remainsToPaid={refundDetail.totalRefundAmount - refundDetail.paidAmount}
							 id={id}
							 reload={setReload}
			/>
		</div>
	);
};

export default CustomerRefundDetail;
